// src/layouts/ClientLayout.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import TaskToolbar from '../pages/chefProjet/TaskToolbar'; // ✅ Correction du chemin d'import
import api from '../api';


const ChefdeporjetLayout = () => {
  const navigate = useNavigate();
  
  const [showForm, setShowForm] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  // Debounce implementation
  useEffect(() => {
    const timerId = setTimeout(() => {
      setSearchTerm(searchInput);
    }, 300); // 300ms delay

    return () => clearTimeout(timerId);
  }, [searchInput]);

  useEffect(() => {
  const timerId = setTimeout(() => {
    setSearchTerm(searchValue);
  }, 300); // Délai de 300ms

  return () => {
    clearTimeout(timerId);
  };
}, [searchValue]);
  
  // ✅ Ajout des filtres manquants
  const [priorityFilter, setPriorityFilter] = useState(null);
  const [typeFilter, setTypeFilter] = useState(null);
  const [moduleFilter, setModuleFilter] = useState(null);
  const [organisationFilter, setOrganisationFilter] = useState(null);
  const [deadlineTechFilter, setDeadlineTechFilter] = useState(null);
  const [deadlineClientFilter, setDeadlineClientFilter] = useState(null);

  // Actions
  const handleShowForm = () => setShowForm(true);
  const handleSearch = useCallback((value) => { setSearchInput(value); }, []);
  const handleDateStart = value => setDateStart(value);
  const handleDateEnd = value => setDateEnd(value);
  
  // ✅ Correction des handlers pour tous les filtres
  const handlePriorityChange = value => setPriorityFilter(value || null);
  const handleTypeChange = value => setTypeFilter(value || null);
  const handleModuleChange = value => setModuleFilter(value || null);
  const handleOrganisationChange = value => setOrganisationFilter(value || null);
  const handleDeadlineTechChange = value => setDeadlineTechFilter(value || null);
  const handleDeadlineClientChange = value => setDeadlineClientFilter(value || null);
  
const handleLogout = async () => {
  try {
    await api.post('/logout'); // Appel vers Laravel
    localStorage.clear();      // Nettoyer localStorage
    navigate('/');             // Rediriger vers login
  } catch (error) {
    console.error('Erreur logout :', error);
    alert('Impossible de se déconnecter.');
  }
};

  // ✅ Fonction pour réinitialiser tous les filtres
  const handleResetFilters = () => {
    setSearchTerm('');
    setDateStart(null);
    setDateEnd(null);
    setPriorityFilter(null);
    setTypeFilter(null);
    setModuleFilter(null);
    setOrganisationFilter(null);
    setDeadlineTechFilter(null);
    setDeadlineClientFilter(null);
  };

  return (
    <div className="flex flex-col h-screen">
      <TaskToolbar
        onShowForm={handleShowForm}
        onSearch={handleSearch}
        onDateStartChange={handleDateStart}
        onDateEndChange={handleDateEnd}
        onPriorityChange={handlePriorityChange}
        onTypeChange={handleTypeChange}
        onModuleChange={handleModuleChange}
        onOrganisationChange={handleOrganisationChange}
        onDeadlineTechChange={handleDeadlineTechChange}
        onDeadlineClientChange={handleDeadlineClientChange}
        onResetFilters={handleResetFilters}
        onLogout={handleLogout}
        // ✅ Passage des valeurs actuelles pour synchronisation
        currentValues={{
          searchTerm,
          dateStart,
          dateEnd,
          priorityFilter,
          typeFilter,
          moduleFilter,
          organisationFilter,
          deadlineTechFilter,
          deadlineClientFilter
        }}
      />
      
      {/* ✅ Passage de tous les filtres au contexte Outlet */}
      <Outlet context={{
        searchTerm,
        dateStart,
        dateEnd,
        priorityFilter,
        typeFilter,
        moduleFilter,
        organisationFilter,
        deadlineTechFilter,      // ← pensez à bien ajouter
        deadlineClientFilter,    // ← ici aussi
        showForm,
        setShowForm
      }} />
    </div>
  );
};

export default ChefdeporjetLayout;